import hopeTheme from './themes/hopeTheme';

export const selectFieldBox = {
  style: {
    width: 'calc(100% - 36px)',
    fontSize: 12,
    backgroundColor: 'white',
    height: 38,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    border: '1px solid #ddd',
    paddingLeft: 16,
    paddingRight: 16,
    marginBottom: 12,
  } as React.CSSProperties,
  hintStyle: {
    fontSize: '12px',
    letterSpacing: '0.5px',
    color: '#999999',
    marginBottom: -6,
  } as React.CSSProperties,
  floatingLabelStyle: {
    marginTop: '-30px',
  },
  floatingLabelShrinkStyle: {
    marginTop: -30,
    zIndex: 100,
    backgroundColor: 'white',
    maxHeight: 12,
    padding: 6,
  },
  floatingLabelFocusStyle: {
    color: hopeTheme.hopeLightPurple,
  } as React.CSSProperties,
  iconStyle: {
    height: 38,
    width: 38,
    top: 0,
    padding: 0,
  } as React.CSSProperties,
  inputStyle: {
    letterSpacing: '0.5px',
    fontWeight: 600,
    marginTop: 0,
    color: hopeTheme.hopeBlack,
  } as React.CSSProperties,
  labelStyle: {
    fontSize: 14,
    height: 38,
    lineHeight: '38px',
    top: 0,
  } as React.CSSProperties,
  underlineStyle: {
    display: 'none',
  } as React.CSSProperties,
};

export const activeSelectFieldBox = {
  ...selectFieldBox,
  style: {
    ...selectFieldBox.style,
    border: `1px solid ${hopeTheme.hopeLightPurple}`,
  } as React.CSSProperties,
};

export const errorSelectFieldBox = {
  ...selectFieldBox,
  style: {
    ...selectFieldBox.style,
    border: `1px solid red`,
  } as React.CSSProperties,
};
// Material-UI TextField takes a dictionary of dictionaries to set the style of various aspects.
interface textFieldStylesType {
  [key: string]: { [key: string]: any };
}

export const inputBoxStyle = {
  style: {
    width: 'calc(100% - 46px)',
    fontSize: 12,
    backgroundColor: 'white',
    height: 38,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    border: '1px solid #ddd',
    paddingLeft: 16,
    paddingRight: 16,
  },
  hintStyle: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    color: '#7a7a7a',
    marginTop: 8,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    bottom: 0,
    position: 'relative',
  },
  inputStyle: {
    textTransform: 'uppercase',
    fontSize: '14px',
    letterSpacing: '0.5px',
    color: '#7a7a7a',
    bottom: 32,
  },
} as React.CSSProperties;

/* inputBoxMobileStyle Not currently used */
export const inputBoxMobileStyle = {
  style: {
    width: 'calc(100% - 34px)',
    fontSize: 12,
    backgroundColor: 'white',
    height: 38,
    overflowX: 'hidden',
    whiteSpace: 'no-wrap',
    textOverflow: 'ellipsis',
    border: '1px solid #ddd',
    paddingLeft: 16,
    paddingRight: 16,
  },
  hintStyle: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    color: '#7a7a7a',
    marginBottom: -6,
  },
  inputStyle: {
    textTransform: 'uppercase',
    fontSize: '14px',
    letterSpacing: '0.5px',
    color: '#7a7a7a',
  },
} as React.CSSProperties;

export const textInputBox = {
  style: {
    width: 'calc(100% - 36px)',
    fontSize: 12,
    backgroundColor: 'white',
    height: 38,
    border: '1px solid #ddd',
    paddingLeft: 16,
    paddingRight: 16,
    marginBottom: 12,
  },
  hintStyle: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    color: '#999999',
    marginBottom: -6,
    top: 6,
  },
  inputStyle: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    fontWeight: 600 as 600,
    marginTop: 0,
    color: hopeTheme.hopeBlack,
  },
  floatingLabelStyle: {
    marginTop: -30,
  },
  floatingLabelShrinkStyle: {
    marginTop: -30,
    zIndex: 100,
    backgroundColor: 'white',
    maxHeight: 12,
    padding: 6,
  },
  textareaStyle: {
    marginTop: 6,
  },
} as textFieldStylesType;

export const textActiveInputBox = {
  style: {
    ...textInputBox.style,
    border: '1px solid #784cab',
  },
  hintStyle: {
    ...textInputBox.hintStyle,
  },
  inputStyle: {
    ...textInputBox.inputStyle,
  },
  floatingLabelStyle: {
    marginTop: -30,
  },
  floatingLabelFocusStyle: {
    marginTop: -30,
    zIndex: 100,
    backgroundColor: 'white',
    maxHeight: 12,
    padding: 6,
  },
  textareaStyle: {
    ...textInputBox.textareaStyle,
  },
} as textFieldStylesType;

export const textErrorInputBox = {
  ...textInputBox,
  style: {
    ...textInputBox.style,
    border: '1px solid red',
  },
} as textFieldStylesType;

export const textMultiLineInputBox = {
  style: {
    width: 'calc(100% - 36px)',
    fontSize: 12,
    backgroundColor: 'white',
    height: 224,
    overflowX: 'hidden',
    whiteSpace: 'no-wrap',
    textOverflow: 'ellipsis',
    border: '1px solid #ddd',
    paddingLeft: 16,
    paddingRight: 16,
  },
  hintStyle: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    color: '#999999',
    marginBottom: -6,
  },
  inputStyle: {
    fontSize: '14px',
    letterSpacing: '0.5px',
    fontWeight: 600,
    color: hopeTheme.hopeBlack,
  },
} as textFieldStylesType;

export const textActiveMultiLineInputBox = {
  ...textMultiLineInputBox,
  style: {
    ...textMultiLineInputBox.style,
    border: '1px solid #784cab',
  },
};

export const textErrorMultiLineInputBox = {
  ...textMultiLineInputBox,
  style: {
    ...textInputBox.style,
    border: '1px solid red',
  },
} as textFieldStylesType;

export const textFieldStyles = {
  underlineFocusStyle: {
    color: '#784cab',
    borderColor: hopeTheme.hopeLightPurple,
  },
  underlineStyle: { borderColor: '#ddd', borderBottom: '1px solid #784cab' },
  errorStyle: { marginTop: 10 },
  floatingLabelStyle: {
    color: '#999',
    fontSize: '14px',
    fontWeight: 400,
    marginTop: -10,
  },
  floatingLabelFocusStyle: { color: hopeTheme.hopeLightPurple },
  hintStyle: { color: '#999' },
  inputStyle: {
    color: '#484848',
    fontSize: '14px',
    fontWeight: 600,
    marginTop: 5,
  },
  style: { backgroundColor: 'transparent', maxHeight: 60 },
} as textFieldStylesType;

export const multiLineTextFieldStyles = {
  underlineFocusStyle: { borderColor: hopeTheme.hopeLightPurple },
  underlineStyle: { borderBottom: '1px solid #784cab' },
  errorStyle: { marginTop: 10 },
  floatingLabelStyle: {
    color: '#999',
    fontSize: '14px',
    fontWeight: 400,
    marginTop: -10,
  },
  floatingLabelFocusStyle: { color: hopeTheme.hopeLightPurple },
  hintStyle: { color: '#999' },
  inputStyle: {
    color: '#484848',
    fontSize: '14px',
    fontWeight: 600,
    marginTop: -8,
  },
  style: { backgroundColor: 'transparent' },
} as textFieldStylesType;

export const multiLineTextFieldStylesAccount = {
  underlineFocusStyle: { borderColor: hopeTheme.hopeLightPurple },
  underlineStyle: { borderBottom: 'none' },
  errorStyle: { marginTop: 10 },
  floatingLabelStyle: {
    color: '#999',
    fontSize: '14px',
    fontWeight: 400,
    marginTop: -10,
  },
  floatingLabelFocusStyle: { color: hopeTheme.hopeLightPurple },
  hintStyle: { color: '#999' },
  inputStyle: {
    color: '#484848',
    fontSize: '14px',
    fontWeight: 600,
    marginTop: -8,
    border: '1px solid #784cab',
  },
  style: { backgroundColor: 'transparent' },
} as textFieldStylesType;

export const alcoholBirthdateInputBox = {
  style: {
    // width: '131px',
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '1px',
    padding: '12px 22px 11px 32px',
  },
};

export const getPresetInputBox = (preset?: string) => {
  // Return a copy of the style.
  switch (preset) {
    case 'alcoholBirthdate':
      return {
        default: { ...alcoholBirthdateInputBox },
        focused: { ...alcoholBirthdateInputBox },
        error: {
          ...alcoholBirthdateInputBox,
          border: '1px solid red',
        },
      };
    default:
      return {
        default: { ...textInputBox },
        focused: { ...textActiveInputBox },
        error: { ...textErrorInputBox },
      };
  }
};
